<div class="file-drop-container">
    <div class="file-drop">
        <ngx-file-drop (onFileDrop)="dropped($event)" 
        dropZoneClassName="my-style"
        contentClassName="my-style" 
        [disabled]="disabled" 
        [multiple]="multiple"
        [accept]="accept">
            <ng-template ngx-file-drop-content-tmp
                let-openFileSelector="openFileSelector">
                <label for="file" class="file-drop-label">
                    <div class="d-flex align-items-center">
                        <div *ngIf="files.length && !isFileUploadingStart" class="insert-file-icon">
                            <mat-icon >insert_drive_file</mat-icon>
                        </div>
                        <div *ngIf="!files.length || isFileUploadingStart" class="cloud-upload-icon">
                            <mat-icon class="material-symbols-outlined">cloud_upload</mat-icon>
                        </div>
                        <div > 
                            <strong>Select a file or drag and drop here</strong>
                            <p class=""> Supported formats: {{supportedFormats}}</p>
                        </div>
                    </div>
                    <button mat-stroked-button class="slect-file-btn" (click)="openFileSelector()">
                        SELECT FILES
                    </button>
                </label>
            </ng-template>
        </ngx-file-drop>
    </div>
    <div *ngIf="files.length" class="mt-2">
        <div class="d-flex align-items-center justify-content-between">
            <p style="margin-bottom: 0px;">Uploaded -
                {{uploadedFileCount}}/{{files.length}}
                Documents
            </p>
            <button mat-stroked-button class="upload-file-btn" (click)="upload()">
                UPLOAD
            </button>
        </div>
    </div>
    <div class="chips-container row">
        <div *ngFor="let item of files; let i = index" style="position: relative;" class="col-sm-3 mt-1">
          <div *ngIf="item.status !== 'ERROR'" class="progress-bar" [style.width.%]="item?.progress || 0"></div>  
          <mat-chip  
          (removed)="delete(i)" class="mx-1" 
          [ngClass]="item.status == 'UPLOADED' ? 'success' : item.status == 'ERROR' ? 'error' : 'default'">
            <span [matTooltip]="item.relativePath" 
            (click)="item.status == 'UPLOADED' ? downloadFile(item.url) : null">
                {{item.relativePath.toLowerCase() | slice:0:8  }}...
            </span>
            <button matChipRemove [attr.aria-label]="'remove template form'" matTooltip="Delete this file">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </div>
    </div>  
</div>